import { useState, useEffect } from "react";
import * as React from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  IconButton,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";

const Copy = (props) => {
  const [open, setOpen] = React.useState(0);
  const [copyFeedback, setCopyFeedback] = React.useState("");
  const handleClose = () => {
    setOpen(0);
  };
  const handleDefaultExpireChange = (e) => {
    props.updateDefaultExpire(e.target.value);
  };
  const copyToClipBoard = async (text, id) => {
    try {
      await navigator.clipboard.writeText(props.url);
      setCopyFeedback("Copied Successfully");
      setOpen(id);
    } catch (err) {
      setCopyFeedback("Failed to copy. Please check browser persmissions");
      setOpen(id);
    }
  };

  return (
    <>
      <Grid
        container
        spacing={1}
        justifyContent="center"
        alignItems="center"
        style={{ marginBottom: "10px" }}
      >
        {/* <Button onClick={() => props.getUrl()}>Generate Link</Button> */}

        <Grid item xs={7}>
          <TextField
            fullWidth
            type="text"
            size="small"
            value={props.url}
            variant="outlined"
            inputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item style={{ display: "flex" }} xs={2}>
          <select
            className="float-right h-10 my-2 mx-1 text-xs w-28 xl-2:w-32 bg-white-1 border border-grey-1 hover:border-grey-1  rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            defaultValue={props.defaultExpiry}
            onChange={(e) => handleDefaultExpireChange(e)}
          >
            <option value="10">10 Day</option>
            <option value="30">30 Days</option>
            <option value="60">60 Days</option>
            <option value="90">90 Days</option>
          </select>
        </Grid>
        <Grid item xs={2}>
          <Tooltip
            open={open === 1}
            onClose={handleClose}
            title={copyFeedback}
            leaveDelay={500}
          >
            <Button
              variant="text"
              // onClick={copy}
              size="small"
              disabled={!props.url}
              style={{
                color: "#0B5FFF",
                fontWeight: "bold",
                textTransform: "capitalize",
                padding:"7px",
              }}
              onClick={() => {
                copyToClipBoard("Text to Copy", 1);
                setTimeout(() => {
                  props.handleClose();
                }, 1500);
              }}
            >
              {open === 1 ? "Copied" : "Copy Link".toLocaleLowerCase()}
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  );
};

export default Copy;
